import { render, staticRenderFns } from "./Percentile.vue?vue&type=template&id=4819e689&scoped=true"
import script from "./Percentile.vue?vue&type=script&lang=js"
export * from "./Percentile.vue?vue&type=script&lang=js"
import style0 from "./Percentile.vue?vue&type=style&index=0&id=4819e689&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4819e689",
  null
  
)

export default component.exports